import ListPermissions from "./List";
import { AccountServicePath, PERMISSIONS } from "utils/constants";
import permissions from "app/permissions";
import LockIcon from "@mui/icons-material/Lock";

//permissions
export const resources = {
  isMenu: true,
  icon: <LockIcon />,
  name: AccountServicePath + PERMISSIONS,
  title: "Права",
  list: <ListPermissions />,
  // edit: <EditIBans />,
  // editPermission: permissions.canChangePermissionsDescription,
  permission: permissions.canPreviewPermissions,
};
